import { useEffect, useState } from 'react';

export function useMounted() {
  const [documentMounted, setDocumentMounted] = useState(false);

  useEffect(() => {
    setDocumentMounted(true);
  }, []);

  return documentMounted;
}
